<template>
  <div class="layout-box">
    <LayoutHeader headtitle="化纤涨跌榜"></LayoutHeader>
    <div class="secondary-content">
      <div class="reprint-box" style="width: 27%">
        <div class="rbox1" style="position: relative" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">当月价格涨跌榜</h3>
          <div id="risechartline" style="width: 100%; height: 100%"></div>
        </div>
        <div class="rbox2" style="position: relative" v-loading="loading4" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">上月价格涨跌榜</h3>
          <div id="risechartline2" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <div class="reprint-box" style="width: 39.2%">
        <div class="rbox2" style="position: relative" v-loading="loading5" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">化纤产业链当月涨跌榜</h3>
          <div id="machartline" style="width: 100%; height: 100%; padding: 40px 15px 0 15px;box-sizing: border-box;">
            <el-table
              :data="advancerslist"
              height="100%"
              size="mini"
              :header-row-style="{background:'none'}"
              :header-cell-style="{background:'none',padding:'6px 0',color:'#fff','border-bottom': '1px solid #2E88FF'}"
              row-class-name="self-owned-table"
              class="nonebak"
              style="width: 100%;color: #fff; font-size: 10px">
              <el-table-column
                prop="dateStr"
                label="当月">
              </el-table-column>
              <el-table-column
                prop="typeName"
                label="类别">
              </el-table-column>
              <el-table-column
                width="170"
                prop="productName"
                label="产品">
              </el-table-column>
              <el-table-column
                label="涨跌幅">
                <template slot-scope="{row}">
                  <span :style="row.amplitudeValue*1==0?'color:#E5CE31':(row.amplitudeValue*1>0?'color:#D94B4F':'color:#26BF6A')">{{row.amplitudeValue}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="幅度">
                <template slot-scope="{row}">
                  <span :style="row.persent*1==0?'color:#E5CE31':(row.persent*1>0?'color:#D94B4F':'color:#26BF6A')">{{row.persent}}%</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="thisAvgValue"
                label="当月月均值">
              </el-table-column>
              <el-table-column
                prop="lastAvgValue"
                label="上月月均值">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="rbox1" style="position: relative" v-loading="loading2" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">化纤产业链上月涨跌榜</h3>
          <div id="machartline2" style="width: 100%; height: 100%; padding: 40px 15px 0 15px;box-sizing: border-box;">
            <el-table
              :data="advancerslist2"
              height="100%"
              size="mini"
              :header-row-style="{background:'none'}"
              :header-cell-style="{background:'none',padding:'6px 0',color:'#fff','border-bottom': '1px solid #2E88FF'}"
              row-class-name="self-owned-table"
              class="nonebak"
              style="width: 100%;color: #fff; font-size: 10px">
              <el-table-column
                prop="dateStr"
                label="当月">
              </el-table-column>
              <el-table-column
                prop="typeName"
                label="类别">
              </el-table-column>
              <el-table-column
                width="170"
                prop="productName"
                label="产品">
              </el-table-column>
              <el-table-column
                label="涨跌幅">
                <template slot-scope="{row}">
                  <span :style="row.amplitudeValue*1==0?'color:#E5CE31':(row.amplitudeValue*1>0?'color:#D94B4F':'color:#26BF6A')">{{row.amplitudeValue}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="幅度">
                <template slot-scope="{row}">
                  <span :style="row.persent*1==0?'color:#E5CE31':(row.persent*1>0?'color:#D94B4F':'color:#26BF6A')">{{row.persent}}%</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="thisAvgValue"
                label="当月月均值">
              </el-table-column>
              <el-table-column
                prop="lastAvgValue"
                label="上月月均值">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="reprint-box">
        <div class="rbox2" style="height: 40.5%;position: relative" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">指标说明</h3>
          <div id="machartline3" style="width: 100%; height: 100%; padding: 40px 15px 0 15px;box-sizing: border-box;">
            <el-table
              :data="indexexplain"
              height="100%"
              :header-row-style="{background:'none'}"
              :header-cell-style="{background:'none',padding:'6px 0',color:'#fff','border-bottom': '1px solid #2E88FF'}"
              row-class-name="self-owned-table"
              class="nonebak"
              style="width: 100%;color: #FFB52B;font-size: 18px">
              <el-table-column
                prop="nameStr"
                label="类别">
              </el-table-column>
              <el-table-column
                prop="description"
                label="名称">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="rbox1" style="height: 58.5%;position: relative" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">价格趋势</h3>
          <div id="risechartline3" style="width: 100%; height: 100%"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import {getTime} from "../../bll/utils";

export default {
  name: 'RiseFallList',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader
  },
  data () {
    return {
      loading:true,
      loading2:true,
      loading3:true,
      loading4:true,
      loading5:true,
      indexexplain:[],
      advancerslist:[],
      advancerslist2:[],
    }
  },
  mounted () {
    const $this=this
    setTimeout(function () {
      $this.getdata()
    },500)
    $this.dataRefresh.$ons('Refresh', () => {
      $this.getdata()
    })
  },
  methods:{
    getdata(){
      const $this=this
      const url = '/api-portal/priceZdb/index';
      $this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datad=datas.data
          const linex=datad.dataX
          const series=[]
          $this.indexexplain=datad.dataY
          datad.dataY.forEach(val=>{
            let dy={
              name: val.nameStr,
              type: 'line',
              data: val.values,
              connectNulls:true,
              showSymbol:false,
            }
            series.push(dy)
          })
          $this.risechartline3(series,linex)
          this.loading3=false
        }
      })
      const url2 = '/api-portal/priceZdb/monthCyl';
      $this.$api.post(url2, {monthType:0}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.advancerslist=datas.data
          this.loading5=false
        }
      },'json')
      $this.$api.post(url2, {monthType:-1}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.advancerslist2=datas.data
          this.loading2=false
        }
      },'json')
      const url3 = '/api-portal/priceZdb/monthZdb';
      $this.$api.post(url3, {monthType:0}, (response) => {
        let datas=response.data||''
        if(datas){
          const datad=(datas.data).reverse()
          let dx=[],dy=[]
          datad.forEach(val=>{
            dx.push(val.value)
            dy.push(val.name)
          })
          $this.risechartline1(dx,dy,'risechartline','#E34E76')
          this.loading=false
        }
      },'json')
      $this.$api.post(url3, {monthType:-1}, (response) => {
        let datas=response.data||''
        if(datas){
          const datad=(datas.data).reverse()
          let dx=[],dy=[]
          datad.forEach(val=>{
            dx.push(val.value)
            dy.push(val.name)
          })
          $this.risechartline1(dx,dy,'risechartline2','#12A2AE')
          this.loading4=false
        }
      },'json')
    },
    risechartline3(series,linex){
      const $this=this
      const myEchartst = $this.$echarts.init(document.getElementById('risechartline3'))
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          textStyle: {
            color: '#C1D3F4'
          },
          itemWidth:12,
          itemHeight:4,
          padding: [50, 0, 0, 0]
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: linex
        },
        yAxis: {
          type: 'value',
          // name:'美元/桶',
          min:val=>{
            return Math.ceil(val.min-5000)>0? Math.ceil(val.min-5000):val.min
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          nameTextStyle:{
            color: '#C1D3F4',
            fontSize:14,
            padding:[0,0,0,40]
          },
          splitLine:{
            show: false
          },
          axisLabel: {
            color: '#C1D3F4',
            formatter: function (params) {
              return parseInt(params/10000)+'万'
            }
          }
        },
        series: series
      }
      myEchartst.setOption(option,true)
    },
    risechartline1(data1,data2,data3,data4){
      const $this=this
      const myEchartst = $this.$echarts.init(document.getElementById(data3))
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '12%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'value',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          splitLine:{show: false},
        },
        yAxis: {
          type: 'category',
          axisLine:{
            show:true,
            onZero: true,
            lineStyle:{
              color:'#191926'
            }
          },
          splitLine:{show: false},
          splitArea:{show: false},
          axisLabel: {
            color: '#C1D3F4',
          },
          data:data2
        },
        series:[
          {
            type: 'bar',
            color:data4,
            stack: 'Total',
            data: data1
          }
        ]
      }
      myEchartst.setOption(option,true)
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  top:0;
  left: 0;
  background: #060614 url("../../assets/bjs.png") no-repeat top/100%;
}

.secondary-content{
  width: 100%;
  height: calc(100% - 20px);
  padding: 0 10px;
  padding-top: 152px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  color: #fff;
}

.reprint-box{
  box-sizing: border-box;
  height: 100%;
  width: 33%;
  display: flex;
  flex-direction:column;
  justify-content: space-between;
  align-items: center;
}

.reprint-box>div{
  border: 1px solid #374E7F;
  box-sizing: border-box;
  height: 49.5%;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.el-table, .el-table__expanded-cell{
  background: none;
}

.nonebak:before{
  background: none;
}

</style>



// WEBPACK FOOTER //
// src/views/secondary/rise-fall-list.vue